<template>
    <div>
        <div class="card" >
            <table style="width:100%">
                <tr>
                    <SortItem title="Invoice ID" @set-sort="setSort" sortKey="id" :sort="sort"/>
                    <SortItem title="Invoice Number" @set-sort="setSort" sortKey="invoice_number" :sort="sort"/>
                    <SortItem title="Name" @set-sort="setSort" sortKey="name" :sort="sort"/>
                    <SortItem title="Phone" @set-sort="setSort" sortKey="phone" :sort="sort"/>
                    <SortItem title="Total amount" @set-sort="setSort" sortKey="total_amount" :sort="sort"/>
                    <SortItem title="Due date" @set-sort="setSort" sortKey="due_date" :sort="sort"/>
                    <SortItem title="Status" @set-sort="setSort" sortKey="status" :sort="sort"/>
                    <SortItem title="Created at" @set-sort="setSort" sortKey="created_at" :sort="sort"/>
                    <SortItem title="Updated at" @set-sort="setSort" sortKey="updated_at" :sort="sort"/>
                </tr>
                <tr v-for="invoice in importInvoices.data" :key="invoice.id" class="table-row" @click="goToDetails(invoice.id)">
                    <td>{{invoice.id}}</td>
                    <td>{{invoice.invoice_number}}</td>
                    <td>{{invoice.customer && invoice.customer.name}}</td>
                    <td>{{invoice.customer && invoice.customer.phone}}</td>
                    <td>{{invoice.total_amount}} kr.</td>
                    <td>{{invoice.due_date}}</td>
                    <td>
                        <Label :status="invoice.status" :error="invoice.callback_response && (JSON.parse(invoice.callback_response).ErrorMessage || (JSON.parse(invoice.callback_response).error_description))"/>
                    </td>
                    <td>{{invoice.created_at}}</td>
                    <td>{{invoice.updated_at}}</td>
                </tr>
            </table>

        </div>
     <div v-if="importInvoices.last_page && (importInvoices.last_page > 1)" class="paginate__wrapper">
      <paginate
        :page-count="importInvoices.last_page || 1"
        :prev-text="'Prev'"
        :click-handler="onPageChange"
        name="invoices"
        :next-text="'Next'"
        :first-last-button="true"
        :container-class="'paginate'"
      ></paginate>
    </div>
    </div>
</template>

<script>
    import Label from '../partials/Label'
    import Paginate from 'vuejs-paginate'
    import SortItem from '../partials/SortItem.vue'
    import * as api from './api.js'
    export default {
        name:'ImportInvoices',
        components:{
            Paginate,
            SortItem,
            Label
        },
        created() {
            this.fetchImportInvoices()
        },
        methods:{
            goToDetails(id) {
                this.$router.push(`/dashboard/invoices/${id}`);
            },
            fetchImportInvoices: async function(){
                this.importInvoices = await api.fetchImportInvoices({
                    id: this.$route.params.id,
                    sort: this.sort,
                    page:this.page
                })
            },
               onPageChange: async function(toPage) {
                this.page = toPage;
                this.fetchImportInvoices();
            },
            setSort(sort){
                if(this.sort.value == sort) {
                    if(this.sort.direction == 'asc') {
                        this.sort.direction = 'desc'
                    } else {
                        this.sort.direction = 'asc'
                    }
                } else {
                    this.sort.value = sort
                    this.sort.direction = 'asc'
                }
                this.fetchImportInvoices()
            },
        },
        data(){
            return {
                importInvoices:{},
                page:1,
                sort:{
                    value:'created_at',
                    direction:'desc'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
